<div
  class="sessions-table w-full overflow-x-auto"
  [class.disabled]="disabled"
>
  <table mat-table [dataSource]="dataSource">
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column" [sticky]="column==='Week'">
      <ng-container *ngIf="column==='Week'">
        <th class="w-[12rem] h-[4.1rem]" mat-header-cell *matHeaderCellDef>
          <div class="t-header h-full flex justify-center items-center">{{column}}</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="t-header t-row-index w-[12rem] lg:w-full h-[4.1rem] flex justify-center items-center">{{element[column]}}</div>
        </td>
      </ng-container>
      <ng-container  *ngIf="column!=='Week'">
        <th class="w-[17rem] h-[4.1rem]" mat-header-cell *matHeaderCellDef>
          <div class="t-header h-full flex justify-center items-center">{{column}}</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <app-session-scheduler-day class="scheduler-container t-d-cell block w-[17rem] lg:w-full h-[4.1rem]" [class.td-cursor]="sessionList.length == maxSessions" [session]="element[column]" (onDaySelect)="onDaySelected($event)"></app-session-scheduler-day>
        </td>
      </ng-container>
    </ng-container>

    <tr class="h-[4.1rem]" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr class="h-[4.1rem]" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
